// @ts-strict-ignore
import { Parameters, WagoApiClient } from '@shared/service/wago-api.client';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { NumberUtils } from '@shared/util/number-utils';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { SharedProjectGroupInfoVO, SharedProjectInfoVO } from '../../permissions/shared-info.vo';
import { UserVO } from '@user/model/vo/user.vo';
import { StringUtils } from '@shared/util/string-utils';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SharedObjectInfoDataService {
  private readonly sharedObjectInfoUrl: string = 'shared-object-info/';
  private readonly getSharedProjectInfoByProjectIdUrl: string = this.sharedObjectInfoUrl + 'project/';
  private readonly getSharedUserUrl: string = this.sharedObjectInfoUrl + 'shared-user/';
  private readonly getSharedProjectGroupInfoByGroupIdUrl: string = this.sharedObjectInfoUrl + 'project-group/';

  constructor(private modelConversionService: ModelConversionService, private wagoApiClient: WagoApiClient) { }

  public getSharedProjectInfoByProjectId(projectId: number): Observable<SharedProjectInfoVO> {
    if (!NumberUtils.isNumber(projectId) || !Number.isInteger(projectId)) {
      return of(null);
    }

    return this.wagoApiClient.get(this.getSharedProjectInfoByProjectIdUrl + projectId).pipe(
      map((response) => this.modelConversionService.convertSharedProjectInfoVO(response)));
  }

  public getSharedUsers(maxResult: number, search: string): Observable<UserVO[]> {
    const parameters: Parameters = this.wagoApiClient.getParameters({});
    parameters.askToElevateUserFromGuestByLoggingIn = true;
    parameters.isErrorHandlingRequired = false;

    let httpParams = new HttpParams();
    httpParams = httpParams.append('maxResult', maxResult.toString());
    if (StringUtils.isNotEmpty(search)) {
      httpParams = httpParams.append('search', search);
    }
    const requestOptions = {
      params: httpParams
    };

    return this.wagoApiClient.get(this.getSharedUserUrl, requestOptions, parameters).pipe(
      map((response) => this.modelConversionService.convertUserVOs(response)));
  }

  public getSharedProjectGroupInfoByGroupId(projectGroupId: number): Observable<SharedProjectGroupInfoVO> {
    if (!NumberUtils.isNumber(projectGroupId) || !Number.isInteger(projectGroupId)) {
      return of(null);
    }

    return this.wagoApiClient.get(this.getSharedProjectGroupInfoByGroupIdUrl + projectGroupId).pipe(
      map((response) => this.modelConversionService.convertSharedProjectGroupInfoVO(response)));
  }

  public saveSharedObjectInfo(sharedProjectInfosVO: SharedProjectInfoVO[],
    sharedProjectGroupInfosVO: SharedProjectGroupInfoVO[]): Observable<boolean> {
    const dto = {
      sharedProjectInfosVO,
      sharedProjectGroupInfosVO
    };
    return this.wagoApiClient.post(this.sharedObjectInfoUrl, dto);
  }
}
